<template>
  <section class="testimonials-area pt-100 pb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="section-title text-center mb-70">
            <h2>{{ content.sectionTitle }}</h2>
            <p>{{ content.sectionDescription }}</p>
          </div>
        </div>
      </div>

      <!-- Testimonial Cards -->
      <div class="testimonial-cards-container">
        <div class="testimonial-cards-grid">
          <div
            class="testimonial-card"
            v-for="testimonial in content.testimonials"
            :key="testimonial.id"
          >
            <div class="testimonial-item-large">
              <div class="testimonial-image-container">
                <img
                  :src="testimonial.image"
                  :alt="testimonial.name"
                  class="testimonial-image"
                />
              </div>
              <div class="testimonial-content-large">
                <div class="testimonial-rating">
                  <i
                    class="fas fa-star"
                    v-for="star in testimonial.rating"
                    :key="star"
                  ></i>
                </div>
                <p class="testimonial-text-large">
                  "{{ testimonial.comment }}"
                </p>
                <div class="testimonial-author-large">
                  <h5>{{ testimonial.name }}</h5>
                  <span>{{ testimonial.position }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeItsTestimonialComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionTitle: "Clients & Case Studies",
        sectionDescription: "Real success stories and testimonials from our clients across various industries.",
        testimonials: [
          {
            id: 1,
            name: "How Sogdo's Cloud Plan Saved $100K/Year for Client",
            position: "Cloud Migration Success Story",
            image: require("@/assets/images/resource/team-01.png"),
            rating: 5,
            comment: "Our cloud migration strategy reduced infrastructure costs by 40% while improving performance and scalability."
          },
          {
            id: 2,
            name: "Migrated legacy fintech systems in 60 days",
            position: "Fintech Modernization Case Study",
            image: require("@/assets/images/resource/team-02.png"),
            rating: 5,
            comment: "Successfully modernized legacy banking systems with zero downtime and enhanced security features."
          },
          {
            id: 3,
            name: "AI-Powered Healthcare Platform Development",
            position: "Healthcare Technology Innovation",
            image: require("@/assets/images/resource/team-03.png"),
            rating: 5,
            comment: "Developed comprehensive healthcare platform with AI diagnostics and patient management systems."
          },
          {
            id: 4,
            name: "E-commerce Platform Scaling to 1M+ Users",
            position: "E-commerce Growth Success",
            image: require("@/assets/images/resource/team-04.png"),
            rating: 5,
            comment: "Scaled e-commerce platform to handle 1M+ concurrent users with 99.9% uptime and optimal performance."
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Testimonials Section */
.testimonials-area {
  position: relative;
  z-index: 1;
  background: linear-gradient(145deg, #0a0f1c, #1a2332);
  color: #fff;
}

.testimonial-cards-container {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.testimonial-cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  margin-top: 50px;
}

.testimonial-card {
  transition: all 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-10px);
}

.testimonial-item-large {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  padding: 40px 30px;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.testimonial-image-container {
  margin-bottom: 25px;
}

.testimonial-image {
  width: 180px;
  height: 180px;
  object-fit: contain;
  border-radius: 15px;
}

.testimonial-content-large {
  max-width: 600px;
  margin: 0 auto;
}

.testimonial-rating {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-bottom: 20px;
}

.testimonial-rating i {
  color: #f6ec4f;
  font-size: 16px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.testimonial-text-large {
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 20px;
  font-style: italic;
  position: relative;
}

.testimonial-author-large h5 {
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 8px;
  font-family: "Archivo", sans-serif;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.testimonial-author-large span {
  color: #f6ec4f;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  display: block;
}

.section-title {
  margin-bottom: 70px;
}

.section-title h2 {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
}

.section-title p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
}

.section-title.text-center {
  text-align: center;
}

/* Responsive Design */
@media only screen and (max-width: 1200px) {
  .testimonials-area {
    padding: 80px 0;
  }
  .testimonial-cards-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
}

@media only screen and (max-width: 991px) {
  .testimonials-area {
    padding: 70px 0;
  }
  
  .testimonial-cards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .testimonial-item-large {
    padding: 35px 25px;
  }

  .testimonial-image {
    width: 140px;
    height: 140px;
  }

  .testimonial-text-large {
    font-size: 15px;
  }

  .testimonial-author-large h5 {
    font-size: 16px;
  }

  .testimonial-author-large span {
    font-size: 13px;
  }
}

@media only screen and (max-width: 767px) {
  .testimonials-area {
    padding: 60px 0;
  }
  
  .testimonial-cards-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .testimonial-item-large {
    padding: 30px 20px;
  }

  .testimonial-image {
    width: 120px;
    height: 120px;
  }

  .testimonial-text-large {
    font-size: 14px;
    line-height: 1.5;
  }

  .testimonial-author-large h5 {
    font-size: 16px;
  }

  .testimonial-author-large span {
    font-size: 12px;
    letter-spacing: 1px;
  }
}

@media only screen and (max-width: 480px) {
  .testimonials-area {
    padding: 40px 0;
  }
  
  .testimonial-item-large {
    padding: 25px 15px;
  }

  .testimonial-image {
    width: 100px;
    height: 100px;
  }

  .testimonial-text-large {
    font-size: 13px;
  }

  .testimonial-author-large h5 {
    font-size: 15px;
  }

  .testimonial-author-large span {
    font-size: 11px;
  }
}
</style>
